import { useState } from 'react';

import { useAcceptHandoff, useRejectHandoff } from '../hooks/use-handoffs';

import { handoffInitiatorLabel, handoffPriorityLabel } from './handoff-labels';

import type { HandoffWireItem } from '../lib/api-client';

/**
 * HandoffAcceptRejectModal — Fatia G.
 *
 * Modal mostrado ao receptor (push) ou candidato (pull) com contextSummary
 * do iniciador. Botões Aceitar / Rejeitar com motivo.
 */
export interface HandoffAcceptRejectModalProps {
  handoff: HandoffWireItem;
  open: boolean;
  onClose: () => void;
}

export function HandoffAcceptRejectModal({
  handoff,
  open,
  onClose,
}: HandoffAcceptRejectModalProps): JSX.Element | null {
  const accept = useAcceptHandoff();
  const reject = useRejectHandoff();
  const [rejectReason, setRejectReason] = useState('');
  const [showRejectForm, setShowRejectForm] = useState(false);

  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-labelledby="handoff-resp-title"
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.4)',
        display: 'grid',
        placeItems: 'center',
        zIndex: 50,
      }}
    >
      <div
        style={{
          backgroundColor: '#fff',
          padding: 20,
          borderRadius: 8,
          width: 460,
          maxWidth: '90vw',
          display: 'grid',
          gap: 12,
        }}
      >
        <h2 id="handoff-resp-title" style={{ margin: 0, fontSize: 16 }}>
          Transferência pendente
        </h2>
        <div style={{ fontSize: 13, display: 'grid', gap: 4 }}>
          <div>
            <strong>De:</strong> {handoffInitiatorLabel(handoff)}
          </div>
          <div>
            <strong>Motivo:</strong> {handoff.reason}
          </div>
          <div>
            <strong>Prioridade:</strong> {handoffPriorityLabel(handoff.priority)}
          </div>
        </div>
        <div
          style={{
            padding: 12,
            backgroundColor: '#f9fafb',
            borderRadius: 6,
            fontSize: 13,
            whiteSpace: 'pre-wrap',
          }}
        >
          {handoff.contextSummary}
        </div>
        {showRejectForm ? (
          <>
            <label style={{ fontSize: 12, display: 'grid', gap: 4 }}>
              Motivo da rejeição
              <input
                value={rejectReason}
                onChange={(e) => setRejectReason(e.target.value)}
                placeholder="ex.: em reunião 2h, indisponível"
                required
                minLength={3}
                maxLength={500}
              />
            </label>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
              <button type="button" onClick={() => setShowRejectForm(false)}>
                Voltar
              </button>
              <button
                type="button"
                disabled={rejectReason.trim().length < 3 || reject.isPending}
                onClick={() =>
                  reject.mutate(
                    { id: handoff.id, version: handoff.version, reason: rejectReason.trim() },
                    { onSuccess: () => onClose() },
                  )
                }
                style={{ backgroundColor: '#dc2626', color: '#fff' }}
              >
                Rejeitar
              </button>
            </div>
          </>
        ) : (
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <button type="button" onClick={() => setShowRejectForm(true)}>
              Rejeitar
            </button>
            <button
              type="button"
              disabled={accept.isPending}
              onClick={() =>
                accept.mutate(
                  { id: handoff.id, version: handoff.version },
                  { onSuccess: () => onClose() },
                )
              }
              style={{ backgroundColor: '#16a34a', color: '#fff' }}
            >
              {accept.isPending ? 'Aceitando…' : 'Aceitar'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
